<template>
  <div id="mefooter">
    <!-- 遍历，5个 -->
    <div v-for="item in meanTree._child" :key="item.id">
      <span @click="getCate({ parent: item })">{{ item.title }}</span>
      <ul>
        <li
          v-for="sitem in item._child"
          :key="sitem.id"
          @click="getCate({ parent: item, _child: sitem })"
        >
          <span href="">{{ sitem.title }}</span>
        </li>
      </ul>
    </div>
    <div class="ewm">
      <img :src="system.qrcode" alt="二维码" />
      <p>扫描关注翱锐生物</p>
      <p>微信公众号</p>
    </div>
    <p>© {{ this.system.copyright }}</p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "meFooter",
  computed: mapGetters(["meanTree", "meanCenterObj", "system"]),
  methods: {
    ...mapActions(["getCate"]),
  },
};
</script>

<style scoped lang='less'>
span {
  cursor: pointer;
}
#mefooter {
  width: 100vw !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: url("../../assets/image/dibu@3x.png");
  background-size: 100vw 26.04vw;
  width: 80vw;
  padding: 4.375vw 10vw;
  display: flex;
  justify-content: space-between;
  align-items: left;
  color: #999;
  font-size: 0.73vw;
  > div {
    > span {
      min-width: 4.6875vw;
      color: #000;
      display: block;
      cursor: pointer;
      text-align: left;
      font-size: 1.25vw;
      font-weight: bold;
      border-bottom: 2px solid #ccc;
      padding-bottom: 1vw;
    }
    > ul {
      list-style: none;

      > li {
        text-align: left;
        margin: 1.04vw 0;
        > a,
        span {
          font-size: 0.73vw;
          text-decoration: none !important;
          color: #ccc;
        }
      }
    }
  }
  > .ewm {
    > p {
      text-align: center;
      line-height: 1.8;
    }
    > img {
      width: 6.25vw;
      height: 6.25vw;
      margin-bottom: 0.52vw;
    }
  }
  > p {
    left: 10vw;
    bottom: 3.02vw;
    position: absolute;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/meFooter.vue